import * as React from 'react'

import Svg, { Path, SvgProps } from 'react-native-svg'

const LockFilled = (props: SvgProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    {...props}
  >
    <Path
      fill="#fff"
      d="M15.041 7.47v-2.2c0-1.858-1.758-3.366-3.925-3.366h-.941c-2.167 0-3.925 1.508-3.925 3.367v2.225a2.833 2.833 0 0 0-2.009 2.7v5.383a2.845 2.845 0 0 0 2.842 2.842H14.3a2.845 2.845 0 0 0 2.841-2.842v-5.383a2.835 2.835 0 0 0-2.1-2.734v.009ZM10.183 3.58h.942c1.225 0 2.258.775 2.258 1.7V7.37h-5.45V5.279c0-.917 1.033-1.7 2.258-1.7h-.008Zm1.034 10.825v1.225c0 .242-.2.442-.442.442H10.3a.445.445 0 0 1-.442-.442v-1.225a1.413 1.413 0 0 1-.733-1.233 1.416 1.416 0 1 1 2.833 0c0 .533-.3.991-.733 1.233h-.008Z"
    />
  </Svg>
)
export default LockFilled
